module.exports = {"510904001":"柔刚街道","510904002":"凤凰街道","510904100":"安居镇","510904101":"东禅镇","510904102":"分水镇","510904103":"石洞镇","510904104":"拦江镇","510904105":"保石镇","510904106":"白马镇","510904107":"中兴镇","510904108":"横山镇","510904109":"会龙镇","510904110":"三家镇","510904111":"玉丰镇","510904112":"西眉镇","510904113":"磨溪镇","510904114":"聚贤镇","510904115":"观音镇","510904116":"常理镇","510904201":"莲花乡","510904203":"步云乡","510904205":"大安乡","510904206":"马家乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510904.json
// module id = 2318
// module chunks = 0